import { makeStyles } from 'tss-react/mui';

const useStylesTextNoWrapBlock: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  textNoWrapBlock: {
    position: 'relative',
    '& > div': {
      position: 'absolute',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
      minWidth: 0,
      width: '100%',
      top: -10,
    },
  },
}));

export default useStylesTextNoWrapBlock;
